var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"newsList"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.listThree)}})])}
var staticRenderFns = []

export { render, staticRenderFns }